import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeadercomponentComponent } from './headercomponent/headercomponent.component';
import { FooterComponent } from './footer/footer.component';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from '../pipes/pipe-module.module';
import { SearchbarComponent } from '../components/searchbar/searchbar.component';
import { PagerComponent } from '../components/pager/pager.component';
import { SlidesCardHomeComponent } from '../components/slides-card-home/slides-card-home.component';
import { PrimaryButtonComponent } from '../components/primary-button/primary-button.component';
import { InfiniteScrollComponent } from '../components/infinite-scroll/infinite-scroll.component';
import { DirectivesModule } from '../directives/directives.module';
import { ProductsComponentModule } from '../products-component/products-component.module';
import { InfoSectionsComponent } from '../components/info-sections/info-sections.component';
import { OptsMenuComponent } from './opts-menu/opts-menu.component';
import { DropdownListComponent } from './dropdown-list/dropdown-list.component';
import { WppFlotanteComponent } from './wpp-flotante/wpp-flotante.component';
import { ChatBotComponent } from './chat-bot/chat-bot.component';
import { ChatBotCardComponent } from './chat-bot-card/chat-bot-card.component';
import { CalcWidthOfSearchbarPipe } from './headercomponent/pipes/calc-width-of-searchbar.pipe';
import { ChangeLanguageComponent } from './change-language/change-language.component';
import { ResponsivePictureSliderComponent } from '../components/slider/components/responsive-picture-slider/responsive-picture-slider.component';
import { SlidesSubscriptionHomeComponent } from '../components/slides-subscription-home/slides-subscription-home.component';

const declarations = [
  HeadercomponentComponent,
  FooterComponent,
  SearchbarComponent,
  PagerComponent,
  SlidesCardHomeComponent,
  SlidesSubscriptionHomeComponent,
  PrimaryButtonComponent,
  InfiniteScrollComponent,
  InfoSectionsComponent,
  OptsMenuComponent,
  DropdownListComponent,
  WppFlotanteComponent,
  ChatBotComponent,
  ChatBotCardComponent,
  CalcWidthOfSearchbarPipe,
  ChangeLanguageComponent,
  ResponsivePictureSliderComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    PipeModule,
    DirectivesModule,
    ProductsComponentModule,
  ],
  exports: declarations,
})
export class GeneralesComponentsModule {}
